module.exports = __webpack_public_path__ + "img/logo.f5f3f0e2.png";